import type { OptionItem } from "@/types/generation.types";
import {
  StyledContainer,
  StyledTitle,
  StyledContentContainer,
  StyledTitleNumber,
  StyledTitleContainer,
  OptionButton,
} from "./OptionList.styles";

export type OptionListProps = {
  number: number;
  title: string;
  options: OptionItem[];
  selectedValue: string | string[] | null;
  onSelect: (value: string | string[]) => void;
  multiSelect?: boolean;
  maxSelections?: number;
};

const OptionList = ({
  number,
  title,
  options,
  selectedValue,
  onSelect,
  multiSelect = false,
  maxSelections,
}: OptionListProps) => {
  const isSelected = (code: string): boolean => {
    if (multiSelect) {
      return Array.isArray(selectedValue) && selectedValue.includes(code);
    }
    return selectedValue === code;
  };

  const handleOptionClick = (code: string) => {
    if (!multiSelect) {
      onSelect(code);
      return;
    }

    const currentSelections = Array.isArray(selectedValue) ? selectedValue : [];
    const isCurrentlySelected = currentSelections.includes(code);

    if (isCurrentlySelected) {
      // 取消選擇
      onSelect(currentSelections.filter((item) => item !== code));
      return;
    }

    if (maxSelections && currentSelections.length >= maxSelections) {
      return;
    }

    onSelect([...currentSelections, code]);
  };

  return (
    <StyledContainer>
      <StyledTitleContainer>
        <StyledTitleNumber>{number} </StyledTitleNumber>
        <StyledTitle>{title}</StyledTitle>
      </StyledTitleContainer>
      <StyledContentContainer>
        {options.map((option) => (
          <OptionButton
            key={option.code}
            onClick={() => handleOptionClick(option.code)}
            $isSelected={isSelected(option.code)}
            disabled={
              multiSelect &&
              maxSelections !== undefined &&
              !isSelected(option.code) &&
              Array.isArray(selectedValue) &&
              selectedValue.length >= maxSelections
            }
          >
            {option.name}
          </OptionButton>
        ))}
      </StyledContentContainer>
    </StyledContainer>
  );
};

export default OptionList;
